import React, { useEffect, useRef, useState, Component } from "react";
import "../assets/css/animate.css";
import "../assets/css/font-awesome.css";
import "../assets/css/bootstrap.min.css";
import "../assets/css/login.css";
import "../assets/css/register.css";
import "../assets/css/custom.css";
import { useNavigate, Link } from "react-router-dom";
import noAccess from "../assets/img/noaccess.png";
import Menus from "./menus";
import { commonAPI } from "../services/CommonAPIService";
import { ErrorSource } from "../common/constants";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import total from "../assets/img/total.png";
import unassigned from "../assets/img/unassigned.png";
import progress from "../assets/img/progress.png";
import hold from "../assets/img/hold.png";
import resolved from "../assets/img/resolved.png";
import aging from "../assets/img/aging.png";
import urgentlevel from "../assets/img/urgentlevel.png";
import societylevel from "../assets/img/societylevel.png";
import servicestaff from "../assets/img/servicestaff.png";
import { Chart } from "react-google-charts";
import onlydots from "../assets/img/3dots.png";
import todayResolve from '../assets/img/resolve-today2.png';
import todayimg from '../assets/img/today.png';
import residentimg from '../assets/img/resident-level.png';
import tp1 from '../assets/img/tp1.png';
import tp2 from '../assets/img/tp2.png';
import tp3 from '../assets/img/tp3.png';
import tp4 from '../assets/img/tp4.png';
import tp5 from '../assets/img/tp5.png';
import tp6 from '../assets/img/tp6.png';


function ComplaintDashboard() {
  const history = useNavigate();
  const [StatusWiseData, setStatusWiseData] = useState([]);
  const [StatusLoading, setStatusLoading] = useState(false);
  const [StatusData, setStatusData] = useState("");
  const [CategoryWiseData, setCategoryWiseData] = useState([]);
  const [CategoryLoading, setCategoryLoading] = useState(false);
  const [MonthlyCount, setMonthlyCount] = useState([]);
  const [MonthlyLoading, setMonthlyLoading] = useState(false);
  const [MetricsCount, setMetricsCount] = useState([]);
  const [MetricsLoading, setMetricsLoading] = useState(false);
  const [AssignedCount, setAssignedCount] = useState([]);
  const [AssignedLoading, setAssignedLoading] = useState(false);
  const [TopResolvedCount, setTopResolvedCount] = useState([]);
  const [TopResolvedLoading, setTopResolvedLoading] = useState(false);
  const [AgingCount, setAgingCount] = useState([]);
  const [AgingCountDays, setAgingCountDays] = useState(7);
  const [AgingLoading, setAgingLoading] = useState(false);
  const [Loading, setLoading] = useState(false);
  const [showAccess, setShowAccess] = useState(false);

  const storedUsername = localStorage.getItem("userData");
  const myUserData = JSON.parse(storedUsername);

  useEffect(() => {
    const storedUsername = localStorage.getItem("userData");
    const myUserData = JSON.parse(storedUsername);
    console.log("useEffect Local storage name", storedUsername);
    if (storedUsername) {
      // If the username is present, redirect to the dashboard
      if (
        myUserData?.roleName == "Society Admin" ||
        myUserData?.roleName == "Society HelpDesk" ||
        myUserData?.roleName == "Super Admin" ||
        myUserData?.roleName == "Society Operator"
      ) {
        setShowAccess(false);
        return;
      } else {
        history("/Dashboard");
        console.log("useEffect Local storage Yes");
        setShowAccess(true);
        return;
      }
    } else if (!storedUsername) {
      history("/");
      console.log("useEffect Local storage No");
    }
  }, [history]);

  function getMonthName(complaintMonth) {
    // Step 1: Extract the month number
    const monthNumber = parseInt(complaintMonth.split('-')[1], 10); // "02" -> 2

    // Step 2: Create an array of month names
    const monthNames = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];

    // Step 3: Get the month name
    return monthNames[monthNumber - 1] || "Invalid month"; // Adjust for zero-based index
}

  const GetStatusWiseData = async () => {
    const auth = localStorage.getItem("userData");
    const myUserData = JSON.parse(auth);
    const endPointVariableKey = {
      buildingId: myUserData?.buildingId,
    };
      setStatusLoading(true);
    try {
      let response = await commonAPI(
        "ComplaintDashboardStatusWise",
        undefined,
        endPointVariableKey
      );
      if (response?.success == true) {
        console.log("ComplaintDashboardStatusWise", response);
        const statusWiseData = response?.data?.statusWiseCount.map((item) => [
          item.statusName,
          item.complaintCount,
        ]);
        console.log("statusWiseData", response?.data);
        setStatusData(response?.data)
        setStatusWiseData(statusWiseData);
        setStatusLoading(false);
      } else {
        toast.error("Something went wrong");
        setStatusLoading(false);
      }
    } catch (error) {
      console.log(error);
      setStatusLoading(false);
      const bodyError = JSON.stringify({
        userId: myUserData?.userId,
        mobileNumber: myUserData?.mobileNumber,
        requestJSON: null,
        uri: "ComplaintDashboardStatusWise",
        errorNumber: "CD01",
        errorSource: ErrorSource,
        errorSummary: error?.message,
        errorDescription: error?.message,
        fileClassName: "CompalintDashboard.js",
        functionName: "GetStatusWiseData",
      });
      let response = await commonAPI("ErrorLogMaster", bodyError);
      console.log("statusCode", response);
      if (response?.success == true && response?.message?.length == 0) {
        toast.error("Something went wrong");
        setStatusLoading(false);
      } else {
        setStatusLoading(false);
        toast.error("Something went wrong");
      }
    }
  };

  const GetCategoryWiseData = async () => {
    const auth = localStorage.getItem("userData");
    const myUserData = JSON.parse(auth);
    const endPointVariableKey = {
      buildingId: myUserData?.buildingId,
    };
    setCategoryLoading(true);
    try {
      let response = await commonAPI(
        "ComplaintDashboardCategoryWise",
        undefined,
        endPointVariableKey
      );
      if (response?.success == true) {
        console.log("ComplaintDashboardStatusWise", response);
        const CategoryWiseCount = response?.data?.categoryWiseCount.map(
          (item) => [item.categoryName, item.complaintCount]
        );
        console.log("categoryWiseCount", CategoryWiseCount);
        setCategoryWiseData(CategoryWiseCount);
        setCategoryLoading(false);
      } else {
        toast.error("Something went wrong");
        setCategoryLoading(false);
      }
    } catch (error) {
      console.log(error);
      setCategoryLoading(false);
      const bodyError = JSON.stringify({
        userId: myUserData?.userId,
        mobileNumber: myUserData?.mobileNumber,
        requestJSON: null,
        uri: "ComplaintDashboardStatusWise",
        errorNumber: "CCD01",
        errorSource: ErrorSource,
        errorSummary: error?.message,
        errorDescription: error?.message,
        fileClassName: "CompalintDashboard.js",
        functionName: "GetCategoryWiseData",
      });
      let response = await commonAPI("ErrorLogMaster", bodyError);
      console.log("statusCode", response);
      if (response?.success == true && response?.message?.length == 0) {
        toast.error("Something went wrong");
        setCategoryLoading(false);
      } else {
        setCategoryLoading(false);
        toast.error("Something went wrong");
      }
    }
  };

  const GetMonthCount = async () => {
     const auth = localStorage.getItem("userData");
     const myUserData = JSON.parse(auth);
     const endPointVariableKey = {
       buildingId: myUserData?.buildingId,
     };
     setMonthlyLoading(true);
     try {
       let response = await commonAPI("ComplaintDashboardMonthlyCount", undefined, endPointVariableKey);
       if (response?.success == true) {
         console.log("ComplaintDashboardMonthlyCount", response);
         const MonthlyWiseCount = response?.data?.map(
           (item) => [getMonthName(item.complaintMonth), item.complaintCount]
         );
         console.log("MonthlyWiseCount", MonthlyWiseCount);
         setMonthlyCount(MonthlyWiseCount);
         setMonthlyLoading(false);
       } else {
         toast.error("Something went wrong");
         setMonthlyLoading(false);
       }
     } catch (error) {
       console.log(error);
       setMonthlyLoading(false);
       const bodyError = JSON.stringify({
         userId: myUserData?.userId,
         mobileNumber: myUserData?.mobileNumber,
         requestJSON: null,
         uri: "ComplaintDashboardMonthlyCount",
         errorNumber: "CCD01",
         errorSource: ErrorSource,
         errorSummary: error?.message,
         errorDescription: error?.message,
         fileClassName: "CompalintDashboard.js",
         functionName: "GetCategoryWiseMonthCount",
       });
       let response = await commonAPI("ErrorLogMaster", bodyError);
       console.log("statusCode", response);
       if (response?.success == true && response?.message?.length == 0) {
         toast.error("Something went wrong");
         setMonthlyLoading(false);
       } else {
        setMonthlyLoading(false);
         toast.error("Something went wrong");
       }
     }
   };

   const GetMetrics = async () => {
    const auth = localStorage.getItem("userData");
    const myUserData = JSON.parse(auth);
    const endPointVariableKey = {
      buildingId: myUserData?.buildingId,
    };
    setMetricsLoading(true);
    try {
      let response = await commonAPI("ComplaintDashboardMetrics", undefined, endPointVariableKey);
      if (response?.success == true) {
        console.log("ComplaintDashboardMetrics", response);
        setMetricsCount(response?.data);
        setMetricsLoading(false);
      } else {
        toast.error("Something went wrong");
        setMetricsLoading(false);
      }
    } catch (error) {
      console.log(error);
      setMetricsLoading(false);
      const bodyError = JSON.stringify({
        userId: myUserData?.userId,
        mobileNumber: myUserData?.mobileNumber,
        requestJSON: null,
        uri: "ComplaintDashboardMetrics",
        errorNumber: "CCD01",
        errorSource: ErrorSource,
        errorSummary: error?.message,
        errorDescription: error?.message,
        fileClassName: "CompalintDashboard.js",
        functionName: "GetMetrics",
      });
      let response = await commonAPI("ErrorLogMaster", bodyError);
      console.log("statusCode", response);
      if (response?.success == true && response?.message?.length == 0) {
        toast.error("Something went wrong");
        setMetricsLoading(false);
      } else {
        setMetricsLoading(false);
        toast.error("Something went wrong");
      }
    }
  };
  
  const GetAssigned = async () => {
    const auth = localStorage.getItem("userData");
    const myUserData = JSON.parse(auth);
    const endPointVariableKey = {
      buildingId: myUserData?.buildingId,
    };
    setAssignedLoading(true);
    try {
      let response = await commonAPI("ComplaintDashboardAssigned", undefined, endPointVariableKey);
      if (response?.success == true) {
        console.log("ComplaintDashboardAssigned", response);
        const AssignedCount = response?.data?.map(
          (item) => [formatUser(item?.userName), item?.complaintsCount, item?.roleName]
        );
        setAssignedCount(AssignedCount);
        setAssignedLoading(false);
      } else {
        toast.error("Something went wrong");
        setAssignedLoading(false);
      }
    } catch (error) {
      console.log(error);
      setAssignedLoading(false);
      const bodyError = JSON.stringify({
        userId: myUserData?.userId,
        mobileNumber: myUserData?.mobileNumber,
        requestJSON: null,
        uri: "ComplaintDashboardAssigned",
        errorNumber: "GA01",
        errorSource: ErrorSource,
        errorSummary: error?.message,
        errorDescription: error?.message,
        fileClassName: "CompalintDashboard.js",
        functionName: "GetAssigned",
      });
      let response = await commonAPI("ErrorLogMaster", bodyError);
      console.log("statusCode", response);
      if (response?.success == true && response?.message?.length == 0) {
        toast.error("Something went wrong");
        setAssignedLoading(false);
      } else {
        setAssignedLoading(false);
        toast.error("Something went wrong");
      }
    }
  };

  const GetTopResolved = async () => {
    const auth = localStorage.getItem("userData");
    const myUserData = JSON.parse(auth);
    const endPointVariableKey = {
      buildingId: myUserData?.buildingId,
    };
    setTopResolvedLoading(true);
    try {
      let response = await commonAPI("ComplaintDashboardTopResolved", undefined, endPointVariableKey);
      if (response?.success == true) {
        console.log("ComplaintDashboardAssigned", response);
        setTopResolvedCount(response?.data);
        setTopResolvedLoading(false);
      } else {
        toast.error("Something went wrong");
        setTopResolvedLoading(false);
      }
    } catch (error) {
      console.log(error);
      setTopResolvedLoading(false);
      const bodyError = JSON.stringify({
        userId: myUserData?.userId,
        mobileNumber: myUserData?.mobileNumber,
        requestJSON: null,
        uri: "ComplaintDashboardAssigned",
        errorNumber: "GTR01",
        errorSource: ErrorSource,
        errorSummary: error?.message,
        errorDescription: error?.message,
        fileClassName: "CompalintDashboard.js",
        functionName: "GetTopResolved",
      });
      let response = await commonAPI("ErrorLogMaster", bodyError);
      console.log("statusCode", response);
      if (response?.success == true && response?.message?.length == 0) {
        toast.error("Something went wrong");
        setTopResolvedLoading(false);
      } else {
        setTopResolvedLoading(false);
        toast.error("Something went wrong");
      }
    }
  };

  const GetAging = async () => {
    const auth = localStorage.getItem("userData");
    const myUserData = JSON.parse(auth);
    const endPointVariableKey = {
      buildingId: myUserData?.buildingId,
    };
    const bodydata = { 
      "ticketAgingDays": AgingCountDays,
    };
    setAgingLoading(true);
    try {
      let response = await commonAPI("ComplaintDashboardAgingCount", bodydata, endPointVariableKey);
      if (response?.success == true) {
        console.log("ComplaintDashboardAgingCount", response);
        setAgingCount(response?.data?.ticketAgingCount);
        setAgingLoading(false);
      } else {
        toast.error("Something went wrong");
        setAgingLoading(false);
      }
    } catch (error) {
      console.log(error);
      setAgingLoading(false);
      const bodyError = JSON.stringify({
        userId: myUserData?.userId,
        mobileNumber: myUserData?.mobileNumber,
        requestJSON: bodydata,
        uri: "ComplaintDashboardAgingCount",
        errorNumber: "GA01",
        errorSource: ErrorSource,
        errorSummary: error?.message,
        errorDescription: error?.message,
        fileClassName: "CompalintDashboard.js",
        functionName: "GetAging",
      });
      let response = await commonAPI("ErrorLogMaster", bodyError);
      console.log("statusCode", response);
      if (response?.success == true && response?.message?.length == 0) {
        toast.error("Something went wrong");
        setAgingLoading(false);
      } else {
        setAgingLoading(false);
        toast.error("Something went wrong");
      }
    }
  };

  const GetStatusWiseDataAuto = async () => {
    const auth = localStorage.getItem("userData");
    const myUserData = JSON.parse(auth);
    const endPointVariableKey = {
      buildingId: myUserData?.buildingId,
    }; 
    try {
      let response = await commonAPI(
        "ComplaintDashboardStatusWise",
        undefined,
        endPointVariableKey
      );
      if (response?.success == true) {
        console.log("ComplaintDashboardStatusWise", response);
        const statusWiseData = response?.data?.statusWiseCount.map((item) => [
          item.statusName,
          item.complaintCount,
        ]);
        console.log("statusWiseData", response?.data);
        setStatusData(response?.data)
        setStatusWiseData(statusWiseData);
        setStatusLoading(false);
      } else {
        toast.error("Something went wrong");
        setStatusLoading(false);
      }
    } catch (error) {
      console.log(error);
      setStatusLoading(false);
      const bodyError = JSON.stringify({
        userId: myUserData?.userId,
        mobileNumber: myUserData?.mobileNumber,
        requestJSON: null,
        uri: "ComplaintDashboardStatusWise",
        errorNumber: "CD01",
        errorSource: ErrorSource,
        errorSummary: error?.message,
        errorDescription: error?.message,
        fileClassName: "CompalintDashboard.js",
        functionName: "GetStatusWiseData",
      });
      let response = await commonAPI("ErrorLogMaster", bodyError);
      console.log("statusCode", response);
      if (response?.success == true && response?.message?.length == 0) {
        toast.error("Something went wrong");
        setStatusLoading(false);
      } else {
        setStatusLoading(false);
        toast.error("Something went wrong");
      }
    }
  };

  const GetCategoryWiseDataAuto = async () => {
    const auth = localStorage.getItem("userData");
    const myUserData = JSON.parse(auth);
    const endPointVariableKey = {
      buildingId: myUserData?.buildingId,
    };
    try {
      let response = await commonAPI(
        "ComplaintDashboardCategoryWise",
        undefined,
        endPointVariableKey
      );
      if (response?.success == true) {
        console.log("ComplaintDashboardStatusWise", response);
        const CategoryWiseCount = response?.data?.categoryWiseCount.map(
          (item) => [item.categoryName, item.complaintCount]
        );
        console.log("categoryWiseCount", CategoryWiseCount);
        setCategoryWiseData(CategoryWiseCount);
        setCategoryLoading(false);
      } else {
        toast.error("Something went wrong");
        setCategoryLoading(false);
      }
    } catch (error) {
      console.log(error);
      setCategoryLoading(false);
      const bodyError = JSON.stringify({
        userId: myUserData?.userId,
        mobileNumber: myUserData?.mobileNumber,
        requestJSON: null,
        uri: "ComplaintDashboardStatusWise",
        errorNumber: "CCD01",
        errorSource: ErrorSource,
        errorSummary: error?.message,
        errorDescription: error?.message,
        fileClassName: "CompalintDashboard.js",
        functionName: "GetCategoryWiseData",
      });
      let response = await commonAPI("ErrorLogMaster", bodyError);
      console.log("statusCode", response);
      if (response?.success == true && response?.message?.length == 0) {
        toast.error("Something went wrong");
        setCategoryLoading(false);
      } else {
        setCategoryLoading(false);
        toast.error("Something went wrong");
      }
    }
  };

  const GetMonthCountAuto = async () => {
     const auth = localStorage.getItem("userData");
     const myUserData = JSON.parse(auth);
     const endPointVariableKey = {
       buildingId: myUserData?.buildingId,
     };
     try {
       let response = await commonAPI("ComplaintDashboardMonthlyCount", undefined, endPointVariableKey);
       if (response?.success == true) {
         console.log("ComplaintDashboardMonthlyCount", response);
         const MonthlyWiseCount = response?.data?.map(
           (item) => [getMonthName(item.complaintMonth), item.complaintCount]
         );
         console.log("MonthlyWiseCount", MonthlyWiseCount);
         setMonthlyCount(MonthlyWiseCount);
         setMonthlyLoading(false);
       } else {
         toast.error("Something went wrong");
         setMonthlyLoading(false);
       }
     } catch (error) {
       console.log(error);
       setMonthlyLoading(false);
       const bodyError = JSON.stringify({
         userId: myUserData?.userId,
         mobileNumber: myUserData?.mobileNumber,
         requestJSON: null,
         uri: "ComplaintDashboardMonthlyCount",
         errorNumber: "CCD01",
         errorSource: ErrorSource,
         errorSummary: error?.message,
         errorDescription: error?.message,
         fileClassName: "CompalintDashboard.js",
         functionName: "GetCategoryWiseMonthCount",
       });
       let response = await commonAPI("ErrorLogMaster", bodyError);
       console.log("statusCode", response);
       if (response?.success == true && response?.message?.length == 0) {
         toast.error("Something went wrong");
         setMonthlyLoading(false);
       } else {
        setMonthlyLoading(false);
         toast.error("Something went wrong");
       }
     }
   };

   const GetMetricsAuto = async () => {
    const auth = localStorage.getItem("userData");
    const myUserData = JSON.parse(auth);
    const endPointVariableKey = {
      buildingId: myUserData?.buildingId,
    };
    try {
      let response = await commonAPI("ComplaintDashboardMetrics", undefined, endPointVariableKey);
      if (response?.success == true) {
        console.log("ComplaintDashboardMetrics", response);
        setMetricsCount(response?.data);
        setMetricsLoading(false);
      } else {
        toast.error("Something went wrong");
        setMetricsLoading(false);
      }
    } catch (error) {
      console.log(error);
      setMetricsLoading(false);
      const bodyError = JSON.stringify({
        userId: myUserData?.userId,
        mobileNumber: myUserData?.mobileNumber,
        requestJSON: null,
        uri: "ComplaintDashboardMetrics",
        errorNumber: "CCD01",
        errorSource: ErrorSource,
        errorSummary: error?.message,
        errorDescription: error?.message,
        fileClassName: "CompalintDashboard.js",
        functionName: "GetMetrics",
      });
      let response = await commonAPI("ErrorLogMaster", bodyError);
      console.log("statusCode", response);
      if (response?.success == true && response?.message?.length == 0) {
        toast.error("Something went wrong");
        setMetricsLoading(false);
      } else {
        setMetricsLoading(false);
        toast.error("Something went wrong");
      }
    }
  };

  const formatUser = (userName) => {
    // Split the userName into words
    const words = userName.split(' ');

    // Check if the number of words is greater than 2
    if (words.length > 2) {
        // Return the first two words and add ellipsis
        return `${words[0]} ${words[1]}...`;
    }

    // Return the original userName if it has 2 or fewer words
    return userName;
};
  
  const GetAssignedAuto = async () => {
    const auth = localStorage.getItem("userData");
    const myUserData = JSON.parse(auth);
    const endPointVariableKey = {
      buildingId: myUserData?.buildingId,
    };
    try {
      let response = await commonAPI("ComplaintDashboardAssigned", undefined, endPointVariableKey);
      if (response?.success == true) {
        console.log("ComplaintDashboardAssigned", response);
        
        const AssignedCount = response?.data?.map(
          (item) => [formatUser(item?.userName), item?.complaintsCount, item?.roleName]
        );
        setAssignedCount(AssignedCount);
        setAssignedLoading(false);
      } else {
        toast.error("Something went wrong");
        setAssignedLoading(false);
      }
    } catch (error) {
      console.log(error);
      setAssignedLoading(false);
      const bodyError = JSON.stringify({
        userId: myUserData?.userId,
        mobileNumber: myUserData?.mobileNumber,
        requestJSON: null,
        uri: "ComplaintDashboardAssigned",
        errorNumber: "GA01",
        errorSource: ErrorSource,
        errorSummary: error?.message,
        errorDescription: error?.message,
        fileClassName: "CompalintDashboard.js",
        functionName: "GetAssigned",
      });
      let response = await commonAPI("ErrorLogMaster", bodyError);
      console.log("statusCode", response);
      if (response?.success == true && response?.message?.length == 0) {
        toast.error("Something went wrong");
        setAssignedLoading(false);
      } else {
        setAssignedLoading(false);
        toast.error("Something went wrong");
      }
    }
  };

  const GetTopResolvedAuto = async () => {
    const auth = localStorage.getItem("userData");
    const myUserData = JSON.parse(auth);
    const endPointVariableKey = {
      buildingId: myUserData?.buildingId,
    };
    try {
      let response = await commonAPI("ComplaintDashboardTopResolved", undefined, endPointVariableKey);
      if (response?.success == true) {
        console.log("ComplaintDashboardAssigned", response);
        setTopResolvedCount(response?.data);
        setTopResolvedLoading(false);
      } else {
        toast.error("Something went wrong");
        setTopResolvedLoading(false);
      }
    } catch (error) {
      console.log(error);
      setTopResolvedLoading(false);
      const bodyError = JSON.stringify({
        userId: myUserData?.userId,
        mobileNumber: myUserData?.mobileNumber,
        requestJSON: null,
        uri: "ComplaintDashboardAssigned",
        errorNumber: "GTR01",
        errorSource: ErrorSource,
        errorSummary: error?.message,
        errorDescription: error?.message,
        fileClassName: "CompalintDashboard.js",
        functionName: "GetTopResolved",
      });
      let response = await commonAPI("ErrorLogMaster", bodyError);
      console.log("statusCode", response);
      if (response?.success == true && response?.message?.length == 0) {
        toast.error("Something went wrong");
        setTopResolvedLoading(false);
      } else {
        setTopResolvedLoading(false);
        toast.error("Something went wrong");
      }
    }
  };

  const GetAgingAuto = async () => {
    const auth = localStorage.getItem("userData");
    const myUserData = JSON.parse(auth);
    const endPointVariableKey = {
      buildingId: myUserData?.buildingId,
    };
    const bodydata = { 
      "ticketAgingDays": AgingCountDays,
    };
    try {
      let response = await commonAPI("ComplaintDashboardAgingCount", bodydata, endPointVariableKey);
      if (response?.success == true) {
        console.log("ComplaintDashboardAgingCount", response);
        setAgingCount(response?.data?.ticketAgingCount);
        setAgingLoading(false);
      } else {
        toast.error("Something went wrong");
        setAgingLoading(false);
      }
    } catch (error) {
      console.log(error);
      setAgingLoading(false);
      const bodyError = JSON.stringify({
        userId: myUserData?.userId,
        mobileNumber: myUserData?.mobileNumber,
        requestJSON: bodydata,
        uri: "ComplaintDashboardAgingCount",
        errorNumber: "GA01",
        errorSource: ErrorSource,
        errorSummary: error?.message,
        errorDescription: error?.message,
        fileClassName: "CompalintDashboard.js",
        functionName: "GetAging",
      });
      let response = await commonAPI("ErrorLogMaster", bodyError);
      console.log("statusCode", response);
      if (response?.success == true && response?.message?.length == 0) {
        toast.error("Something went wrong");
        setAgingLoading(false);
      } else {
        setAgingLoading(false);
        toast.error("Something went wrong");
      }
    }
  };

  useEffect(() => {
    GetStatusWiseData();
    GetCategoryWiseData();
    GetMonthCount();
    GetMetrics();
    GetAssigned();
    GetTopResolved();
  }, []);

  useEffect(() => {
    GetStatusWiseDataAuto();
    GetCategoryWiseDataAuto();
    GetMonthCountAuto();
    GetMetricsAuto();
    GetAssignedAuto();
    GetTopResolvedAuto();

    const intervalId = setInterval(() => {
      setLoading(true);
      GetStatusWiseDataAuto();
      GetCategoryWiseDataAuto();
      GetMonthCountAuto();
      GetMetricsAuto();
      GetAssignedAuto();
      GetTopResolvedAuto();
    }, 120000); // 120000 milliseconds = 2 minutes

    return () => clearInterval(intervalId); // Cleanup on unmount

  }, []);


  useEffect(() => {
    GetAging();
  }, [AgingCountDays]);

  useEffect(() => {
    GetAgingAuto(); // Initial fetch when component mounts or AgingCountDays changes

    const intervalId = setInterval(() => {
      GetAgingAuto(); // Auto-refresh every 2 minutes
    }, 120000); // 120000 milliseconds = 2 minutes

    return () => clearInterval(intervalId); // Cleanup on unmount
}, [AgingCountDays]); // Dependency array includes AgingCountDays

  const data = [
    ["x", "Complaints"],
    ...MonthlyCount,
//     [0, 0],
//     [1, 10],
//     [2, 23],
//     [3, 17],
//     [4, 18],
//     [5, 9],
//     [6, 11],
//     [7, 27],
//     [8, 33],
//     [9, 40],
//     [10, 32],
//     [11, 35],
  ];

  const options = {
    hAxis: { title: "Month-wise" },
    vAxis: { title: "Complaint count" },
    legend: "none",
  };

  const data1 = [
    ["Task", "Hours per Day"],
    ...CategoryWiseData,
    // ["Work", 11],
    // ["Eat", 2],
    // ["Commute", 2],
    // ["Watch TV", 2],
    // ["Sleep", 7], // CSS-style declaration
  ];

  const options1 = {
    pieHole: 0.4,
    is3D: false,
  };

  const data2 = [
    ["Element", "Complaint", { role: "style" }],
    ...AssignedCount
    // ["Copper", 5, "#b87333"], // RGB value
    // ["Silver", 10, "silver"], // English color name
    // ["Gold", 15, "gold"],
    // ["Platinum", 20, "color: #e5e4e2"], // CSS-style declaration
  ];

  const data3 = [
    ["Task", "Hours per Day"],
    ...StatusWiseData,
    // ["Work", 9],
    // ["Eat", 2],
    // ["Commute", 2],
    // ["Watch TV", 2],
    // ["Sleep", 7],
  ];

  

  const options3 = {};
  
  return (
    <>
      <Menus />
      <ToastContainer />
      {myUserData?.roleName == "Society Admin" || myUserData?.roleName == "Society HelpDesk" || myUserData?.roleName == "Super Admin"  || myUserData?.roleName == "Society Operator" ?
      <div className="dashalign">
        <div className="container-fluid mt-5">
          <div className="cs">
             <h1> Complaint Statistics</h1>
          </div>
          <div className="row">
            <div className="col-lg-2 col-md-2 col-sm-12 col-12">
            <Link onClick={() => localStorage.setItem("lastTabManagent", "tab3")} to="/Management"  className={'text-black p-0 nav-link'}>
              <div className="complaintboxes ">
               {StatusLoading ?
                    <span class="skeleton-loader"></span>
               :null}
                <div className="totalimg">
                  <img src={total} className="img img-fluid" />
                </div>
                <div className="totaltext">
                  <h1> {StatusData ? StatusData?.totalCount : 0} </h1>
                  <span> Total</span>
                </div>
              </div>
            </Link>  
            </div>
            <div className="col-lg-2 col-md-2 col-sm-12 col-12">
              <Link onClick={() => {localStorage.setItem("lastTabManagent", "tab3"); localStorage.setItem("StatusHelp", "1, 4");}} to="/Management"  className={'text-black p-0 nav-link'}>
                <div className="complaintboxes">
                  {StatusLoading ?
                        <span class="skeleton-loader"></span>
                  :null}
                  <div className="totalimg">
                        <img src={unassigned} className="img img-fluid" />
                  </div>
                  <div className="totaltext">
                        <h1> {StatusData?.statusWiseCount?.[0]?.complaintCount ? StatusData?.statusWiseCount[0]?.complaintCount  +  StatusData?.statusWiseCount[3]?.complaintCount : 0} </h1>
                        <span> Unassigned</span>
                  </div>
                </div>
              </Link>  
            </div>
            <div className="col-lg-2 col-md-2 col-sm-12 col-12">
            <Link onClick={() => {localStorage.setItem("lastTabManagent", "tab3"); localStorage.setItem("StatusHelp", "2");}} to="/Management"  className={'text-black p-0 nav-link'}>
              <div className="complaintboxes">
                {StatusLoading ?
                    <span class="skeleton-loader"></span>
               :null}
                <div className="totalimg">
                  <img src={progress} className="img img-fluid" />
                </div>
                <div className="totaltext">
                  <h1>{StatusData?.statusWiseCount?.[1]?.complaintCount ? StatusData?.statusWiseCount[1]?.complaintCount : 0}</h1>
                  <span> In-Progress</span>
                </div>
              </div>
            </Link>  
            </div>
            <div className="col-lg-2 col-md-2 col-sm-12 col-12">
            <Link onClick={() => {localStorage.setItem("lastTabManagent", "tab3"); localStorage.setItem("StatusHelp", "3");}} to="/Management"  className={'text-black p-0 nav-link'}>
              <div className="complaintboxes">
                {StatusLoading ?
                    <span class="skeleton-loader"></span>
               :null}
                <div className="totalimg">
                  <img src={hold} className="img img-fluid" />
                </div>
                <div className="totaltext">
                  <h1> {StatusData?.statusWiseCount?.[2]?.complaintCount ? StatusData?.statusWiseCount[2]?.complaintCount : 0} </h1>
                  <span> Hold </span>
                </div>
              </div>
            </Link>  
            </div>
            <div className="col-lg-2 col-md-2 col-sm-12 col-12">
              <Link onClick={() => {localStorage.setItem("lastTabManagent", "tab3"); localStorage.setItem("StatusHelp", "5");}} to="/Management"  className={'text-black p-0 nav-link'}>
                <div className="complaintboxes">
                {StatusLoading ?
                      <span class="skeleton-loader"></span>
                :null}
                  <div className="totalimg">
                    <img src={resolved} className="img img-fluid" />
                  </div>
                  <div className="totaltext">
                    <h1> {StatusData?.statusWiseCount?.[4]?.complaintCount ? StatusData?.statusWiseCount[4]?.complaintCount : 0} </h1>
                    <span> Resolved </span>
                  </div>
                </div>
              </Link>
            </div>
            <div className="col-lg-2 col-md-2 col-sm-12 col-12">
              <div className="complaintboxes">
              {AgingLoading ?
                    <span class="skeleton-loader"></span>
               :null}
                <div class="elleisemode">
                  <img src={onlydots} className="img img-fluid" />
                  <div class="ellipsemodetext">
                    <ul>
                      {/* <li>
                        {" "}
                        <Link href="#"> XYZ </Link>
                      </li> */}
                      <li style={{padding: "0px 0px 0px", fontSize: "12px", color: AgingCountDays == 7 ? "#20aee3": "#000", cursor: "pointer"}} onClick={() => setAgingCountDays(7)}> One Weeks </li>
                      <li style={{padding: "9px 0px 0px" , fontSize: "12px", color: AgingCountDays == 14 ? "#20aee3": "#000", cursor: "pointer"}} onClick={() => setAgingCountDays(14)}> Two Weeks </li>
                      <li style={{padding: "9px 0px 0px" , fontSize: "12px", color: AgingCountDays == 30 ? "#20aee3": "#000", cursor: "pointer"}} onClick={() => setAgingCountDays(30)}> One Month </li>
                      <li style={{padding: "9px 0px 0px",fontSize: "12px",  color: AgingCountDays == 90 ? "#20aee3": "#000", cursor: "pointer"}} onClick={() => setAgingCountDays(90)}> Three Month </li>
                    </ul>
                  </div>
                </div>
                <div className="totalimg">
                  <img src={aging} className="img img-fluid" />
                </div>

                <div className="totaltext">
                  <h1> {AgingCount ? AgingCount : 0} </h1>
                  <span> Aging </span>
                </div>
              </div>
            </div>
          </div>
          <div className="row mt-4">
            <div className="col-lg-6 col-md-5 col-sm-12 col-12">
              <div className="Charts__0093_Element">
                {MonthlyLoading ?
                 <span class="skeleton-loader_chart"></span>
                 :null}
           
              <div className="chartstats">
                <h4> Month-wise complaint count </h4>
              </div>
              <Chart
                chartType="LineChart"
                width="100%"
                height="300px"
                data={data}
                options={options}
              />
            </div>
            </div>
            <div className="col-lg-2 col-md-2 col-sm-12 col-12">
            <div className="Charts__0093_Element">
              {MetricsLoading ?
                <span class="skeleton-loader_chart"></span>
                :null}
              <div className="currentstat_00">
              
                  <h4> Current Stats </h4>

                  
                  <Link onClick={() => {localStorage.setItem("lastTabManagent", "tab3"); localStorage.setItem("UrgentStats", true);}} to="/Management"  className={'text-black p-0 nav-link'}>                  
                    <div className="flexComb__shift">
                      <div className="currentimg">
                          <img src={urgentlevel} className="img img-responsive" />
                      </div>
                      <div className="currentimgtext">
                          <label> Urgent Complaints</label>
                          <span> {MetricsCount?.urgentOpenTickets} </span>
                      </div>
                    </div>
                  </Link>

                  <div className="border-bottom--99"></div>
                    <Link onClick={() => {localStorage.setItem("lastTabManagent", "tab3"); localStorage.setItem("SocietyLevel", "SOCIETY");}}  to="/Management"  className={'text-black p-0 nav-link'}>
                      <div className="flexComb__shift">
                            <div className="currentimg">
                                <img src={societylevel} className="img img-responsive" />
                            </div>
                            <div className="currentimgtext">
                                <label> Society Complaints</label>
                                <span> {MetricsCount?.societyLevelOpenTickets}  </span>
                            </div>
                      </div>
                    </Link> 
                  <div className="border-bottom--99"></div>
                    <Link onClick={() => {localStorage.setItem("lastTabManagent", "tab3"); localStorage.setItem("StatusHelp", "1"); localStorage.setItem("TodayStartDate", new Date()); localStorage.setItem("TodayEndDate", new Date());}}  to="/Management"  className={'text-black p-0 nav-link'}>
                      <div className="flexComb__shift">
                            <div className="currentimg">
                                <img src={todayimg} className="img img-responsive" />
                            </div>
                            <div className="currentimgtext">
                                <label> Todays Open</label>
                                <span> {MetricsCount?.todayOpenTickets}  </span>
                            </div>
                      </div>
                    </Link>
                  <div className="border-bottom--99"></div>
                    <Link onClick={() => {localStorage.setItem("lastTabManagent", "tab3"); localStorage.setItem("StatusHelp", "4"); localStorage.setItem("TodayStartDate", new Date()); localStorage.setItem("TodayEndDate", new Date());}}  to="/Management"  className={'text-black p-0 nav-link'}>
                      <div className="flexComb__shift">
                            <div className="currentimg">
                                <img src={todayResolve} className="img img-responsive" />
                            </div>
                            <div className="currentimgtext">
                                <label> Todays Resolved </label>
                                <span> {MetricsCount?.todayResolvedTickets}  </span>
                            </div>
                      </div>
                    </Link>  
                  <div className="border-bottom--99"></div>
                    <Link onClick={() => {localStorage.setItem("lastTabSystem", "tab5");}} to="/SystemSetting"  className={'text-black p-0 nav-link'}>                  
                      <div className="flexComb__shift">
                            <div className="currentimg">
                                <img src={servicestaff} className="img img-responsive" />
                            </div>
                            <div className="currentimgtext">
                                <label> Service Staff </label>
                                <span> {MetricsCount?.serviceStaffInSociety}  </span>
                            </div>
                      </div>
                    </Link>  
                  <div className="border-bottom--99"></div>
                  <div className="flexComb__shift">
                        <div className="currentimg">
                            <img src={residentimg} className="img img-responsive" />
                        </div>
                        <div className="currentimgtext">
                            <label> Resident Count</label>
                            <span> {MetricsCount?.residingResidents} </span>
                        </div>
                  </div>

              </div>
              </div>
            </div>
            
            <div className="col-lg-4 col-md-5 col-sm-12 col-12">
            <div className="Charts__0093_Element">
            {CategoryLoading ?
              <span class="skeleton-loader_chart"></span>
             :null} 
              <div className="chartstats">
             
                <h4> Category-wise complaint </h4>
              </div>
              <Chart
                chartType="PieChart"
                data={data1}
                options={options1}
                width={"100%"}
                height={"300px"}
              />
            </div>
            </div>
          </div>
          <div className="row mt-4">
            <div className="col-lg-6 col-md-5 col-sm-12 col-12">
              <div className="Charts__0093_Element">
                {AssignedLoading ?
                  <span class="skeleton-loader_chart"></span>
                  :null}
                <div className="chartstats">
                  <h4> Current Assingment </h4>
                </div>
                {AssignedCount.length ?
                  <Chart
                    chartType="ColumnChart"
                    width="100%"
                    height="335px"
                    data={data2}
                  />
                :<p style={{backgroundColor: "#fff", textAlign: "center", height: 330, paddingTop: 145}}>No data</p>}  
              </div>  
            </div>
            <div className="col-lg-2 col-md-2 col-sm-12 col-12">
              <div className="Charts__0093_Element">
              {/* TopResolvedLoading */}
              {TopResolvedLoading ?
                    <span class="skeleton-loader_chart"></span>
               :null}
                <div className="currentstat">
                    <h4> Top Performer </h4>
                    {TopResolvedCount.length
                      ? TopResolvedCount.map((item, index) => (
                        <>
                          <div className="flexComb__shift">
                            {/* {index === 0 ? ( 
                              <div  className="starperformer">
                                <img src={tp} className="img img-responsive" />
                              </div>
                            ):null}   */}
                            {index === 0 ? (
                            <div className="statsimg">
                              <img src={tp1} className="img img-responsive" />
                            </div>):null}
                            {index === 1 ? (
                            <div className="statsimg">
                              <img src={tp2} className="img img-responsive" />
                            </div>):null}
                            {index === 2 ? (
                            <div className="statsimg">
                              <img src={tp3} className="img img-responsive" />
                            </div>):null}
                            {index === 3 ? (
                            <div className="statsimg">
                              <img src={tp4} className="img img-responsive" />
                            </div>):null}
                            {index === 4 ? (
                            <div className="statsimg">
                              <img src={tp5} className="img img-responsive" />
                            </div>):null}
                            {index === 5 ? (
                            <div className="statsimg">
                              <img src={tp6} className="img img-responsive" />
                            </div>):null}
                            <div className="statstext">
                                <h6> {item?.userName}  </h6>
                                <label> {item?.roleName} </label>
                                <span> {item?.complaintsCount} </span>
                            </div>
                          </div>
                          <div className="border-bottom"></div>
                        </>
                      ))
                      : <p style={{backgroundColor: "#fff", textAlign: "center", height: 311, paddingTop: 145}}>No data</p>}
                    
                </div>
              </div>  
            </div>
            <div className="col-lg-4 col-md-5 col-sm-12 col-12">
            {StatusLoading ?
                 <span class="skeleton-loader_chart"></span>
               :null}
              <div className="chartstats">
                <h4> Complaints by Status </h4>
              </div>
              <Chart
                chartType="PieChart"
                data={data3}
                options={options3}
                width={"100%"}
                height={"92%"}
              />
              
            </div>
          </div>
        </div>
      </div>
      :null}     

      {showAccess && <div className='bg-white ' style={{ height: "400px", borderRadius: "10px", marginTop: "100px", margin: "100px" }}>
           <div className='col-12 text-center'>
           <img src={noAccess} alt="user" className="mx-auto mt-5" style={{ height: "150px" }} />
           </div>
           <br />
           <h3 className='col-12 text-center' style={{ marginTop: "0px" }}> You don't have any access</h3>
           <h5 className='col-12 text-center' style={{ marginTop: "10px" }}> Please contact Admin </h5>
      </div>}
    </>
  );
}
export default ComplaintDashboard;
